export default __webpack_public_path__ + "static/media/photo13.76733f47.jpeg";